import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { toast } from 'react-hot-toast'
import { useAdminAuth } from '../hooks/useAdminAuth'

interface AdminRouteProps {
  children: React.ReactNode
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { loading, hasAdminAccess } = useAdminAuth()
  const location = useLocation()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Yükleniyor...</p>
        </div>
      </div>
    )
  }

  if (!hasAdminAccess) {
    toast.error('Bu sayfaya erişmek için admin yetkisi gereklidir')
    return <Navigate to="/" state={{ from: location }} replace />
  }

  return <>{children}</>
}

export default AdminRoute